<template>
	<div class="page-layout blank contacts-manage">
		<div class="pb-10 pl-3 pr-3">
			<h2 class="ml-0 mb-0 mt-0">
				<div class="d-flex flex-wrap justify-content-between align-items-center">
					<div class="breadcrumbactive">
						<div>
							<span class="pointer">Sales Forecast</span>
						</div>
					</div>
				</div>
			</h2>
			<div class="pt-6" style="background-color:#fff;border-radius:8px">
				<div v-if="ajaxCallInProgress && sales_forecast_details == null" class="d-flex align-items-center justify-content-center w-100">
					<half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
				</div>
				<div v-else>
					<button type="button" class="btn btn-primary back-btn ml-4 mb-2" @click="backButton()">Back</button>
					<div class="main-div">
						<div class="create-company-header d-flex align-items-center justify-content-between">
							<span class="fs-14  pl-10 text-white ml-3 header-text">{{sales_forecast_details.name}}</span>
							<span class="description-text-header-right" style="padding-right: 30px;">
								<span class="fs-14  pl-3 text-white ml-3 header-value">{{sales_forecast_details.territory}}</span>
								<img class="header-spacing" src="/static/icons/crm/pin.svg" alt />
							</span>
						</div>
					</div>
					<div class="container-fluid table-contents">
						<span class="fs-14 title-header">{{deal_data.list.deal_owner}}</span>
						<div class="table-datas my-6">
                            <!-- Table Section -->
							<table class="team-smallview-table w-100 table-responsive text-center">
								<thead>
									<tr>
										<th class="th-sm">Target Amount ({{currency}})</th>
										<th class="th-sm">Achieved Deals (1)</th>
										<th class="th-sm">Achieved (%)</th>
										<th class="th-sm">Deals in Pipeline ({{sales_forecast_details.pipeline_count}})</th>
										<th class="th-sm">Remaining (%)</th>
										<th class="th-sm">Predicted Probability</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{sales_forecast_details.target}}</td>
										<td style="color:#2b71d5;">{{sales_forecast_details.total_achieved}}</td>
										<td>{{sales_forecast_details.percentage_achieved}}</td>
										<td>{{sales_forecast_details.pipeline_amount}}</td>
										<td>{{sales_forecast_details.remaining}}</td>
										<td>{{sales_forecast_details.predicted_probability}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div>
							<div class="mb-4">
							<span class="fs-14 title-header">Pipeline Deals</span>
							</div>
							<div class="fs-14 fw-600 text-center mt-12" v-if="!ajaxCallInProgress && deal_list.length == 0">
                                No Data
                            </div>
                            <div v-else class="d-flex" style="flex-wrap:wrap">
                                <div class="w-25" v-for="(list,index) in deal_list" :key="index">
									<div class="p-2 d-flex justify-content-between" style="background-color: #005dae;border-radius: 5px 5px 0 0;">
										<span class="fs-14 fw-600 px-2 text-white text-capitalize">
											{{list.stage_name.replace("_", " ")}} ({{list.count}})
										</span>
									</div>
                                    <div>
                                        <div class="bord-blue pb-2" style="min-height: 350px;max-height:200px;overflow: auto;">
                                            <div class="fs-14 fw-600 text-center mt-12" v-if="list.deals.length == 0">
                                                No Data
                                            </div>
                                            <div v-else class="d-flex flex-column p-2 mt-2 mx-2"
                                                :id="deal.deal_id" v-for="(deal,deal_index) in list.deals"
                                                :key="deal_index"
                                                style="box-shadow: 0 0 6px 0 #939393;"
                                            >
                                                <div class="d-flex justify-content-between">
                                                    <div class="d-flex flex-column justify-content-between">
                                                        <div class="d-flex">
                                                            <span class="fs-12 fw-600 px-2 pointer text-secondary">
                                                                {{deal.name}}
                                                            </span>
                                                        </div>
                                                        <span class="fs-12 fw-600 px-2">
                                                            Amount ({{currency}}) : {{deal.transaction_value}}
                                                        </span>
                                                        <span class="fs-12 fw-600 px-2">
                                                            Expected Date : {{deal.expected_close_date}}
                                                        </span>
                                                    </div>
                                                    <div class="d-flex flex-column justify-content-between pt-8" >
                                                        <el-dropdown v-model="priority" trigger="click" class="text-right" >
                                                            <i class="icon icon-circle fs-20 text-right " :class="{'text-dark-red': deal.priority == 'high', 'text-medium-status': deal.priority == 'medium', 'text-low-status': deal.priority == 'low'}"></i>
                                                            <el-dropdown-menu slot="dropdown" class="priority-cursor">
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-dark-red">High</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-medium-status">Medium</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-low-status">Low</span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-2 d-flex justify-content-between bordradblr-5px" style="background-color: #e69d57;">
                                            <span class="fs-12 fw-600">
                                                Total ({{currency}})
                                            </span>
                                            <span class="fs-12 fw-600">
                                                {{list.total}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EventBus } from '../eventBus/nav-bar-event';
import salesforecast from "../mixins/salesforecast";
import { HalfCircleSpinner } from "epic-spinners";
export default {
	mixins:[salesforecast],
	components: {
        HalfCircleSpinner
    },
    data(){
        return {
			ajaxCallInProgress: false,
			deal_list: null,
			deal_data: null,
			sales_forecast_details: null,
			priority: 'high',
			deal_stage:[],
            deal_stage_id :'',
			is_true :false,
            currency:'',
        }
    },
    methods:{
       backButton(){
		this.$router.push("/salesForeCast/view_sales_forecast/"+this.$route.params.id)
       },
	   async loadViewDealsDetails(){
		   	this.deal_list = [];
			this.ajaxCallInProgress = true
			let params = {
				skip: 0,
                limit: 10,
                owner_id: this.deal_data.list.owner_id,
                deal_pipeline_id: this.deal_data.list.deal_pipeline_id,
                status: this.deal_data.selected_deal,
                sales_forecast_id: this.$route.params.id,
				}
			let response = await this.getViewDealsDetails(params)
			this.deal_list = response.response
			this.sales_forecast_details = response.sales_forecast_info
			this.deal_list.forEach((x)=> {
                this.deal_stage = x.stage_name
                this.deal_stage_id = x.stage_id
                if(this.deal_stage == 'deal_won' || this.deal_stage == 'deal_lost'){
                    this.is_true = true
                } else {
                    this.is_true = false
                }
            })
			this.ajaxCallInProgress = false
		}
    },
	mounted() {
		this.deal_data = JSON.parse(localStorage.getItem('deal_details'))
		this.loadViewDealsDetails()
        this.currency = this.loggedInUser.currency.symbol;
	},
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        }
    },
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #005dae;
    }

	.table-contents{
		padding: 10px 40px 50px 80px;
	}
	.table-datas{
		border: 1px solid #707070;
    	border-radius: 5px;
	}
	.team-smallview-table thead tr th {
		background: #005dae;
		color: #fff;
		padding: 10px 66px;
		font-size: 13px;
		font-weight: 400;
		white-space: nowrap;
		width:50%;
		text-align: left;
	}
	.team-smallview-table tbody tr td {
		background: #fff;
		padding: 10px 66px;
		font-size: 13px;
		font-weight: 400;
		border-bottom: 1px solid #f2f3f5;
		white-space: nowrap;
		width:50%;
		text-align: left;
	}
	.team-smallview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-smallview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .team-smallview-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
	.title-header{
		color: #0475f3;
		font-weight: 500;
	}
	.description-text-header-right {
		font-size: 24px;
		margin-left: auto;
		padding-left: 12px;
		color: #005dae;
		font-weight: 500;
	}
	.header-value {
		padding-right: 10px;
	}
	.back-btn{
		background-color: #646464 !important;
		border-radius: 8px;
	}

	.priority-cursor.el-dropdown-menu__item {
        cursor : not-allowed !important
    }
	.text-dark-red {
        color: #f80c17;
    }
    .text-medium-status {
        color: #ff9a35;
    }
    .text-low-status {
        color: #005dae;
    }
	.dropdown-toggle:empty::after {
        display: none;
    }
    .w-25 {
        width: 24% !important;
        margin-right: 10px !important;
    }

    .bord-blue {
        border: 1px solid #00448b !important;
    }

    .bordradblr-5px {
        border-radius: 0 0 5px 5px !important;
    }

    @media screen and (max-width:992px) {
        .w-25 {
            width: 49% !important;
            margin-right: 10px !important;
        }
    }

    @media (max-width: 1300px) {
        .flex-width {
            max-width: 100% !important;
            width: 100% !important;
            flex: 0 0 100% !important;
            transition: 0.5s ease all;
        }
    }

    @media screen and (max-width:992px) {
        .stage-sections-right {
            height: 375px;
        }

        .prod-var-max-ht {
            max-height: 256px !important;
        }
    }
    .dropdown-toggle-deals:empty::after {
        display: none;
    }
    .text-dark-blue {
        color: #00448b;
    }
    @media screen and (max-width:992px) {
        .w-25 {
            width: 48% !important;
            margin-right: 10px !important;
        }
    }

    .dropdown-toggle-deals::after {
        display: none;
    }

    .dropdown-menu.dropdown-width li:hover {
        background-color: #ecf1f9 !important;
        color: #00448b !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/DisplayDeals.vue